'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FundNext = require('./FundNext.css');

var _FundNext2 = _interopRequireDefault(_FundNext);

var _ = require('../');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundNext = (_dec = (0, _reactCssModules2.default)(_FundNext2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundNext, _Component);

  function FundNext(props) {
    (0, _classCallCheck3.default)(this, FundNext);
    return (0, _possibleConstructorReturn3.default)(this, (FundNext.__proto__ || (0, _getPrototypeOf2.default)(FundNext)).call(this, props));
  }

  (0, _createClass3.default)(FundNext, [{
    key: 'render',
    value: function render() {
      var ticker = this.props.ticker ? this.props.ticker : 'N';
      var name = _format2.default.sanitize(this.props.name);
      var prevUrl = _config2.default.routes.fund + '/' + name + '/' + ticker + '/' + this.props.prev + '/' + this.props.fundId + '/' + this.props.investmentVehicleId;
      var nextUrl = _config2.default.routes.fund + '/' + name + '/' + ticker + '/' + this.props.next + '/' + this.props.fundId + '/' + this.props.investmentVehicleId;

      return _react2.default.createElement(
        'div',
        { styleName: 'next-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'next-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'next-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'next' },
              this.props.prev ? _react2.default.createElement(
                'div',
                { styleName: 'next-left' },
                _react2.default.createElement(
                  _.Link,
                  {
                    to: prevUrl,
                    title: this.props.prevLabel },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'label-left' },
                    _react2.default.createElement('i', { className: 'fa fa-angle-double-left' }),
                    ' ',
                    this.props.prevLabel
                  )
                )
              ) : _react2.default.createElement('div', { styleName: 'next-left' }),
              _react2.default.createElement(
                'span',
                { styleName: 'label' },
                this.props.ticker
              ),
              this.props.next ? _react2.default.createElement(
                'div',
                { styleName: 'next-right' },
                _react2.default.createElement(
                  _.Link,
                  {
                    to: nextUrl,
                    title: this.props.nextLabel },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'label-right' },
                    this.props.nextLabel,
                    _react2.default.createElement(_.LinkIcon, null)
                  )
                )
              ) : _react2.default.createElement('div', { styleName: 'next-right' })
            )
          )
        )
      );
    }
  }]);
  return FundNext;
}(_react.Component), _class2.propTypes = {
  prev: _react.PropTypes.string,
  prevLabel: _react.PropTypes.string,
  next: _react.PropTypes.string,
  nextLabel: _react.PropTypes.string,
  ticker: _react.PropTypes.string,
  name: _react.PropTypes.string.isRequired,
  investmentVehicleId: _react.PropTypes.string.isRequired,
  fundId: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = FundNext;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FundNext/FundNext.js
// module id = 1382
// module chunks = 0